import { useTranslation } from 'react-i18next';
import { IconCategoryCoffee, businessCategoryIcons } from './business-category-icons';
import { Marquee } from './marquee';

/** Infinite scroller of business-category pills, shared by the business Hero
 *  and the app Hero. Reads the category labels from i18n (`hero.categories`)
 *  and pairs each with its colored icon by index. */
export function CategoryMarquee() {
  const { t } = useTranslation();
  const categories = t('hero.categories', { returnObjects: true }) as Array<string>;

  return (
    <Marquee aria-label={t('hero.title')}>
      {categories.map((label, index) => {
        const CategoryIcon = businessCategoryIcons[index] ?? IconCategoryCoffee;
        return (
          <span
            key={label}
            className="bg-surface flex shrink-0 items-center gap-2 rounded-full py-1.5 pl-1.5 pr-4"
          >
            <span className="bg-canvas flex size-10 items-center justify-center rounded-full">
              <CategoryIcon className="size-6" aria-hidden />
            </span>
            <span className="text-text-primary whitespace-nowrap text-base">{label}</span>
          </span>
        );
      })}
    </Marquee>
  );
}
